
import { DatePicker } from '@/components/ui/date-picker';
import { FormFieldWrapper } from '@/components/ui/form-field-wrapper';
import { useTimezone } from '@/contexts/TimezoneContext';
import { useEffect } from 'react';

interface TransactionDateFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

export const TransactionDateField = ({ value, onChange, error, disabled }: TransactionDateFieldProps) => {
  const { getCurrentDateInUserTimezone, isTimezoneReady } = useTimezone();

  // Set today's date as default if no value is provided
  useEffect(() => {
    if (!value && isTimezoneReady) {
      const todayString = getCurrentDateInUserTimezone();
      console.log('TransactionDateField - Setting default date (corrected):', todayString);
      onChange(todayString);
    }
  }, [value, onChange, getCurrentDateInUserTimezone, isTimezoneReady]);

  const handleDateChange = (date: Date | undefined) => {
    console.log('TransactionDateField - Date input changed:', date);
    
    if (!date) {
      onChange('');
      return;
    }
    
    // Conversão direta sem manipulação de timezone
    // A data já vem no timezone local do navegador
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    
    console.log('TransactionDateField - Final date string (corrected):', dateString);
    onChange(dateString);
  };

  // Para exibição, criar data local sem conversão de timezone
  const displayDate = value ? (() => {
    try {
      const [year, month, day] = value.split('-').map(Number);
      if (year && month && day) {
        const date = new Date(year, month - 1, day);
        console.log('TransactionDateField - Display date created:', date, 'from value:', value);
        return date;
      }
    } catch (error) {
      console.error('TransactionDateField - Error parsing date:', error);
    }
    return undefined;
  })() : undefined;

  console.log('TransactionDateField - Rendering with value:', value, 'displayDate:', displayDate);

  return (
    <FormFieldWrapper 
      label="Data" 
      required={true}
      error={error}
    >
      <DatePicker
        date={displayDate}
        onDateChange={handleDateChange}
        placeholder="Selecionar data"
        disabled={disabled}
        className="rounded-xl"
      />
    </FormFieldWrapper>
  );
};
